import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Role } from '../models/ui/role.model';
import { EmployeeRoleSdk } from '../sdks/employee-role.sdk';
import { User } from '../models/ui/user.model';
import { Department } from '../models/ui/department.model';
import { DepartmentSdk } from '../sdks/department.sdk';
import { UserManager } from './user.manager';

@Injectable({
	providedIn: 'root'
})
export class EmployeeRoleManager {
	public employeeCollection$: Observable<User[]>;
	private employeeCollectionSource: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);

	constructor(
		private employeeRoleSdk: EmployeeRoleSdk,
		private departmentSdk: DepartmentSdk,
		private userManager: UserManager) {
		this.employeeCollection$ = this.employeeCollectionSource.asObservable();
	}

	public getEmployeeRoles(): Observable<Role[]> {
		return this.employeeRoleSdk.getEmployeeRoles();
	}

	public getDepartments(): Observable<Department[]> {
		return this.departmentSdk.getDepartments();
	}

	public refreshLexbeEmployees(): void {
		this.userManager.getEmployeeUsers().subscribe(data => {
			this.employeeCollectionSource.next(data);
		});
	}

	public updateUserEmployeeRoles(params: UpdateUserEmployeeRolesParams): Observable<void> {
		if(params?.userId && params?.roles)
			return this.employeeRoleSdk.updateUserEmployeeRoles(params);
	}
}

interface UpdateUserEmployeeRolesParams {
	userId: string;
	roles: string[];
}
